<template>
  <div>
    <div v-if="getPurchaseOrder.payment.payments.length > 0" >
      <section class="content invoice po-payment--summary">
        <zee-payments-header :item="item"></zee-payments-header>
        <br>
        <zee-payments-table :item="item"></zee-payments-table>
        <hr>
        <zee-payments-timeline
          :item="item"
          v-if="getPurchaseOrder.payment.payments.length > 0"></zee-payments-timeline>
      </section>
    </div>
    <el-row
      v-loading="isAddPaymentInfoLoading"
      :gutter="20"
      v-if="getPurchaseOrder.payment.payments.length == 0 && (checkUserGroup(getGroups.FACTORY) ||
    checkUserGroup(getGroups.MANAGE))">
      <el-col
        :span="12"
        :offset="6">
        <h3 class="text-center">PO needs more<strong> informations</strong>. Add below:</h3><br>
        <el-form
          label-position="top"
          :model="addPaymentInfoForm"
          :rules="rules"
          ref="addPaymentInfoForm"
          label-width="120px"
          class="add-payment-info-form">
          <fieldset class="payment-due-date">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="PAYMENT DUE DATE 1"
                  prop="paymentDueDate">
                  <el-date-picker
                    v-model="addPaymentInfoForm.paymentDueDate"
                    type="date"
                    format="dd/MM/yyyy"
                    size="large"
                    align="center"
                    :editable="isEditable"
                    placeholder="Select the payment due date">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="PAYMENT DUE DATE 2 (OPTIONAL)"
                  prop="paymentDueDate2">
                  <el-date-picker
                    v-model="addPaymentInfoForm.paymentDueDate2"
                    type="date"
                    format="dd/MM/yyyy"
                    size="large"
                    align="center"
                    :editable="isEditable"
                    placeholder="Select the payment due date 2">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="10"
              v-if="!proFormaAdded">
              <el-col :span="24">
                <el-form-item label="ADD PRO FORMA? (OPTIONAL)">
                  <el-button
                    @click="addProFormaDialog = true;"
                    class="btn-block">Add file</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="PAYMENT OBS"
                  prop="paymentObs">
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Add a payment observation"
                    v-model="addPaymentInfoForm.paymentObs">
                  </el-input>
                </el-form-item>
                <p style="margin-top:5px;">
                  <i class="el-icon-information"></i>
                  <em> Write here how this PO should be payed. (Installments, at once)</em>
                </p>
              </el-col>
            </el-row>

            <el-form-item>
              <el-button
                type="success"
                @click="addPaymentInfo('addPaymentInfoForm')"
                class="btn-block">Add payment information</el-button>
            </el-form-item>
          </fieldset>
        </el-form>
      </el-col>
    </el-row>
    <div
      v-if="(!checkUserGroup(getGroups.FACTORY) && !checkUserGroup(getGroups.MANAGE)) &&
    getPurchaseOrder.payment.payments.length == 0">
      <div class="tile-stats">
        <div class="row">
          <h3 class="text-center empty-title">No payment info defined.</h3>
        </div>
      </div>
    </div>
    <el-dialog
      title="Add pro forma file"
      :visible.sync="addProFormaDialog">
      <el-upload
        class="upload-demo"
        drag
        ref="upload"
        :headers="getHeaders"
        :action="getUploadProFormaUrl"
        :on-error="onUploadError"
        :on-success="onUploadSucces"
        :before-upload="setIsFileUpload"
        :auto-upload="true">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
      </el-upload>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          :plain="true"
          :disabled="isFileUpload"
          @click="addProFormaDialog = false;">Add later</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as groups from '@/js/user-groups';
import apiUrl from '@/services/api_url';
import getFileUploadHeaders from '@/services/http-file-headers';
import zeePaymentsTable from './payment-partials/PoPaymentsTable.vue';
import zeePaymentsHeader from './payment-partials/PoPaymentsHeader.vue';
import zeePaymentsTimeline from './payment-partials/PoPaymentsTimeline.vue';

export default {
  components: {
    zeePaymentsTable,
    zeePaymentsHeader,
    zeePaymentsTimeline,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      hasActivities: true,
      hasPaymentDue: false,
      paymentReceiptObservation: '',
      selectedPaymentId: null,
      isEditable: false,
      isFileUpload: false,
      isAddPaymentInfoLoading: false,
      addProFormaDialog: false,
      proFormaAdded: false,
      addPaymentInfoForm: {
        paymentDueDate: '',
        paymentDueDate2: '',
        fileList: [],
        paymentObs: '',
      },
      rules: {
        paymentDueDate: [
          { type: 'date', required: true, message: 'Due date is required' },
        ],
        paymentObs: [
          { required: true, message: 'Payment obs. is required', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser',
    }),
    getGroups() {
      return groups;
    },
    getPurchaseOrder() {
      return this.$store.getters.getPOItem;
    },
    getHeaders() {
      return getFileUploadHeaders();
    },
    getUploadProFormaUrl() {
      return `${apiUrl}pos/${this.item.id}/sendProForma/`;
    },
  },
  created() {
    this.$store.dispatch('setPoPayment', this.item.payment);
  },
  methods: {
    checkUserGroup(group) {
      if (process.env.NODE_ENV === 'production') {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()) {
            return true;
          }
        }
      }
      return true;
    },
    setIsFileUpload() {
      this.isFileUpload = true;
    },
    onUploadSucces() {
      this.$message.success('Success! File uploaded.');
      this.isFileUpload = false;
      this.addProFormaDialog = false;
      this.proFormaAdded = true;
    },
    onUploadError() {
      this.$message.error('Oops! Something went wrong.');
      this.isFileUpload = false;
    },
    addPaymentInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const paymentDue = JSON.stringify(this.addPaymentInfoForm.paymentDueDate);
          const cleanDate = paymentDue.substring(0, paymentDue.indexOf('T')).replace('"', '');
          let paymentObj = {};
          if (this.addPaymentInfoForm.paymentDueDate2 !== '' && typeof this.addPaymentInfoForm.paymentDueDate2 !== 'undefined') {
            const paymentDue2 = JSON.stringify(this.addPaymentInfoForm.paymentDueDate2);
            const cleanDate2 = paymentDue2.substring(0, paymentDue2.indexOf('T')).replace('"', '');
            paymentObj = {
              payment: {
                payments: [
                  { due: cleanDate }, { due: cleanDate2 },
                ],
                observation: this.addPaymentInfoForm.paymentObs,
              },
            };
          } else {
            paymentObj = {
              payment: {
                payments: [
                  { due: cleanDate },
                ],
                observation: this.addPaymentInfoForm.paymentObs,
              },
            };
          }
          this.$store.dispatch('setPaymentDue', {
            poId: this.item.id,
            paymentId: this.item.payment.id,
            paymentDue: paymentObj,
            scope: this,
          });
          this.$store.dispatch('getSearchedPaymentTransactionsData');
        }
        return false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.masked-input-radius .el-input__inner {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
h1 {
  display: inline-block;
  margin: 0;
}

.invoice-title {
  line-height:1;
  font-size: 1.9em;
  text-transform: capitalize;
}

.empty-title {
  margin: 50px 0;
}

.payment-timeline {
  width: 100%;
}
.show-amount-paid {
  position: absolute;
  top: 0;
  left: -20px;
}
.dialog-footer {
  .total-left {
    line-height: 3;
    text-transform: uppercase;
  }
}
.empty-title {
  margin: 50px 0;
}
.el-form-item__label {
  color: #73879C;
}
.el-form-item .el-form--label-top .el-form-item__label {
  font-size: .9em;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoPaymentSummary.vue